import TextAreaControlled from './TextAreaControlled';

export default TextAreaControlled;